
// Utility functions for Excel and Zip downloads
import * as XLSX from 'xlsx';
import JSZip from 'jszip';
import { saveAs } from 'file-saver';

export function downloadExcelFromJson(data, filename) {
    let newData = [];
    data.forEach(item => {
        newData.push(formulateData(item));
    });
    const ws = XLSX.utils.json_to_sheet(newData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    saveAs(new Blob([wbout], { type: 'application/octet-stream' }), filename + '.xlsx');
}

export async function downloadDistrictWiseExcelZip(data, filename, districtKey = 'dc') {
    const zip = new JSZip();
    const grouped = {};
    data.forEach(item => {
        const key = item[districtKey] || 'Unknown';
        let newKey = key.split("-")[0].trim(); // Extract district code before hyphen
        if (!grouped[newKey]) grouped[newKey] = [];
        grouped[newKey].push(formulateData(item));
    });
    Object.entries(grouped).forEach(([district, records]) => {
        const ws = XLSX.utils.json_to_sheet(records);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
        const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
        zip.file(`${district}.xlsx`, wbout);
    });
    const content = await zip.generateAsync({ type: 'blob' });
    saveAs(content, filename + '.zip');
}
export function downloadWelfareSchemeExcel(data, filename) {
    const filtered = data
        .filter(item => item.isWelfareScheme)
        .map(item => ({
            UID: item.uid,
            Name: item.name,
            'Father Name': item.fname,
            'Mobile Number': item.mno,
            'Welfare Scheme': item.isWelfareScheme ? "Yes" : "No",
            Nominee: item.nominee || "",
            District: item.district && item.district.length > 1 ? item.district[0] + " - " + item.district[1] : (item.district || ""),
            'District Code': item.dc
        }));
    const ws = XLSX.utils.json_to_sheet(filtered);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    saveAs(new Blob([wbout], { type: 'application/octet-stream' }), filename + '.xlsx');
}

export async function downloadDistrictWiseWelfareSchemeExcelZip(data, filename, districtKey = 'dc') {
    const zip = new JSZip();
    const grouped = {};
    data.filter(item => item.isWelfareScheme).forEach(item => {
        const key = item[districtKey] || 'Unknown';
        let newKey = key.split("-")[0].trim(); // Extract district code before hyphen
        if (!grouped[newKey]) grouped[newKey] = [];
        grouped[newKey].push({
            UID: item.uid,
            Name: item.name,
            'Father Name': item.fname,
            'Mobile Number': item.mno,
            'Welfare Scheme': item.isWelfareScheme ? "Yes" : "No",
            Nominee: item.nominee || "",
            District: item.district && item.district.length > 1 ? item.district[0] + " - " + item.district[1] : (item.district || ""),
            'District Code': item.dc
        });
    });
    Object.entries(grouped).forEach(([district, records]) => {
        const ws = XLSX.utils.json_to_sheet(records);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
        const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
        zip.file(`${district}.xlsx`, wbout);
    });
    const content = await zip.generateAsync({ type: 'blob' });
    saveAs(content, filename + '.zip');
}

function formulateData(data) {
    let item = {};
    item['UID'] = data.uid
    item['Name'] = data.name
    item['Father Name'] = data.fname
    item['Blood Group'] = data.bg
    item['District'] = data.district[0] + " - " + data.district[1]
    item['District Code'] = data.dc;
    item['Date of Birth'] = data.dob
    item['Address'] = data.add1 + ", " + data.add2 + ", " + data.add3 + " - " + data.pin
    item['Pincode'] = data.pin
    item['Mobile Number'] = data.mno
    item['Membership Status'] = data.status
    item['Created Timestamp'] = data.timestamp
    item['Last Modified Timestamp'] = data.alteredTimestamp
    item['Welfare Scheme'] = data.isWelfareScheme ? "Yes" : "No"
    item['Nominee'] = data.nominee || ""
    return item;
} 
